const lanes = [
  { key: "waiting_to_scan", label: "Waiting to scan" },
  { key: "needs_pricing", label: "Needs pricing" },
  { key: "ready_to_list", label: "Ready to list" },
  { key: "listed", label: "Listed" },
  { key: "sold", label: "Sold" },
];

export default function ProcessingQueueBoard({ items, onStatusChange, updatingId }) {
  const counts = Object.fromEntries(lanes.map((lane) => [lane.key, 0]));
  items.forEach((item) => {
    counts[item.lane] = (counts[item.lane] || 0) + 1;
  });

  return (
    <section className="queue-board" data-testid="processing-queue-dashboard">
      <div className="queue-lane-grid" data-testid="processing-queue-lanes">
        {lanes.map((lane) => (
          <article key={lane.key} className="queue-lane-count">
            <span>{lane.label}</span>
            <strong data-testid={`queue-count-${lane.key}`}>{counts[lane.key]}</strong>
          </article>
        ))}
      </div>
      <div className="queue-table-wrap">
        <table className="library-table queue-table" data-testid="processing-queue-table">
          <thead>
            <tr>
              <th>Card</th>
              <th>Set</th>
              <th>Condition</th>
              <th>Qty</th>
              <th>Cost</th>
              <th>Queue status</th>
            </tr>
          </thead>
          <tbody>
            {items.map((item) => (
              <tr key={item.queue_id} data-testid={`processing-queue-row-${item.queue_id}`}>
                <td>
                  <strong>{item.card_name}</strong>
                  <span>{item.storage_label || "Unassigned"}</span>
                </td>
                <td>{item.set_name || "No set"}{item.set_code ? ` · ${item.set_code}` : ""}</td>
                <td>{item.condition || "—"}</td>
                <td>{item.quantity}</td>
                <td>${item.unit_cost}</td>
                <td>
                  <select
                    value={item.lane}
                    disabled={updatingId === item.queue_id}
                    onChange={(event) => onStatusChange(item.queue_id, event.target.value)}
                    data-testid={`processing-queue-status-${item.queue_id}`}
                  >
                    {lanes.map((lane) => (
                      <option key={lane.key} value={lane.key}>
                        {lane.label}
                      </option>
                    ))}
                  </select>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
      {!items.length && (
        <div className="workspace-empty" data-testid="processing-queue-empty-state">
          <h2>Nothing is waiting in the queue.</h2>
          <p>Cards added through Intake will appear here for scanning, pricing, and listing.</p>
        </div>
      )}
    </section>
  );
}